import { useRoutes } from "react-router-dom";

import React from 'react'
import Svgs from "../components/Svgs";
import Svgcategory from "../components/Svgcategory";
import Editor from "../components/Editor";
export default function Routes() {
    const element = useRoutes([
       
        {
          path: "/",
        //   element: <Svgs />,
          children: [
            {
              element: <Svgs />,
              index: true,
            },
            // { path: "login", element: <Login /> },
            // { path: "svg", element: <Svgs /> },
            { path: "logocategory", element: <Svgcategory /> },
            { path: "editor", element: <Editor /> },


         
           
          ],
        },
        // { path: "*", element: <Navigate to={"/"} /> },
      ]);
    
      return element;
}
